// extracted by mini-css-extract-plugin
module.exports = {"valueInputs":"MultiplePasteInput_valueInputs__33rni"};